import { h, ComponentChildren } from 'preact'

export const SectionTitle = ({ children }: { children: ComponentChildren }) => (
  <div className='a-section-title'>{children}</div>
)

export const SectionHeader = ({ children }: { children: string }) => (
  <div className='m-section-header'>
    <SectionTitle>{children}</SectionTitle>
  </div>
)

export const SectionBody = ({ children }: { children: ComponentChildren}) => (
  <div className='m-section-body'>{children}</div>
)

const Section = ({ title, children }: { title: string, children: ComponentChildren}) => {
  return (
    <div className='m-section'>
      <SectionHeader>{title}</SectionHeader>
      <SectionBody>{children}</SectionBody>
    </div>
  )
}

export default Section
